module.exports = __webpack_public_path__ + "static/media/img1.54b8a8d1.jpg";